$(document).ready(function () {
  (function () {
    const $gallery = document.querySelector('.vertical-gallery');
    const $dots = Array.from(document.querySelectorAll('.gallery-dot'));
    const $thumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
    const $wrappers = Array.from(document.querySelectorAll('.vertical-gallery-wrapper'));
    if (!$gallery) return;

    // modal elements
    const modal = document.getElementById('VerticalGalleryModal');
    const modalBody = modal ? document.getElementById('VerticalGalleryModalBody') : null;
    const closeBtn = modal ? modal.querySelector('[data-vertical-modal-close]') : null;
    const overlay = modal ? modal.querySelector('[data-vertical-modal-overlay]') : null;

    // open modal
    function openVerticalGalleryModal(startIndex = 0) {
      if (!modal || !modalBody || !$gallery) return;

      // clone main gallery
      const galleryClone = $gallery.cloneNode(true);

      // remove video items
      const clonedItems = galleryClone.querySelectorAll('.vertical-gallery__item');
      clonedItems.forEach(function (item) {
        if (item.querySelector('video')) item.remove();
      });

      // build dots
      const items = galleryClone.querySelectorAll('.vertical-gallery__item');
      const dotsWrapper = document.createElement('div');
      dotsWrapper.className = 'gallery-dots';
      items.forEach(function (item, idx) {
        const dot = document.createElement('div');
        dot.className = 'gallery-dot' + (idx === 0 ? ' active' : '');
        dot.setAttribute('data-index', idx);
        dotsWrapper.appendChild(dot);
      });

      // build thumbs
      const thumbsWrapper = document.createElement('div');
      thumbsWrapper.className = 'gallery-thumbs';
      items.forEach(function (item, idx) {
        const img = item.querySelector('img');
        if (!img) return;
        const thumb = document.createElement('button');
        thumb.className = 'gallery-thumb' + (idx === 0 ? ' active' : '');
        thumb.type = 'button';
        thumb.setAttribute('data-index', idx);
        thumb.innerHTML = img.outerHTML;
        thumbsWrapper.appendChild(thumb);
      });

      // replace modal content
      modalBody.innerHTML = '';
      modalBody.appendChild(galleryClone);
      modalBody.appendChild(dotsWrapper);
      modalBody.appendChild(thumbsWrapper);

      // init modal gallery
      setupModalGalleryBehavior(galleryClone, dotsWrapper, thumbsWrapper, startIndex);

      // init panzoom
      initModalPanzoom(galleryClone);

      // show modal
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');

      // lock scroll
      $('html, body').addClass('vertical-gallery-modal-open');
    }

    // modal behavior
    function setupModalGalleryBehavior(modalGallery, dotsWrapper, thumbsWrapper, initialIndex = 0) {
      const modalDots = Array.from(dotsWrapper.querySelectorAll('.gallery-dot'));
      const modalThumbs = thumbsWrapper ? Array.from(thumbsWrapper.querySelectorAll('.gallery-thumb')) : [];

      // get modal item size
      function getItemSize() {
        return window.innerWidth >= 990 ? modalGallery.clientHeight : modalGallery.clientWidth;
      }

      // get modal scroll position
      function getScrollPos() {
        return window.innerWidth >= 990 ? modalGallery.scrollTop : modalGallery.scrollLeft;
      }

      // get current index
      function getCurrentIndex() {
        const size = getItemSize();
        if (!size) return 0;
        return Math.round(getScrollPos() / size);
      }

      let lastIndex = -1;

      // update active state
      function updateActive() {
        const idx = getCurrentIndex();

        if (idx !== lastIndex) {
          const zones = modalGallery.querySelectorAll('.panzoom');
          zones.forEach((zone) => {
            if (typeof zone._pzReset === 'function') {
              zone._pzReset();
            }
          });
          lastIndex = idx;
        }

        modalDots.forEach((d) => d.classList.remove('active'));
        if (modalDots[idx]) modalDots[idx].classList.add('active');

        modalThumbs.forEach((t) => t.classList.remove('active'));
        if (modalThumbs[idx]) {
          modalThumbs[idx].classList.add('active');
          modalThumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      // scroll to index
      function scrollToIndex(index) {
        const size = getItemSize();
        const opts = { behavior: 'smooth', top: 0, left: 0 };
        if (window.innerWidth >= 990) opts.top = index * size;
        else opts.left = index * size;
        modalGallery.scrollTo(opts);
      }

      // dot click
      modalDots.forEach((dot) => {
        dot.addEventListener('click', () => {
          scrollToIndex(parseInt(dot.getAttribute('data-index'), 10) || 0);
        });
      });

      // thumb click
      modalThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          scrollToIndex(parseInt(thumb.getAttribute('data-index'), 10) || 0);
        });
      });

      // update active on scroll
      modalGallery.addEventListener('scroll', updateActive);

      // scroll to clicked image (with delay)
      const safeIndex = Math.max(0, Math.min(initialIndex, modalDots.length - 1));
      setTimeout(() => {
        scrollToIndex(safeIndex);
        setTimeout(updateActive, 80);
      }, 300);

      updateActive();
    }

    function initModalPanzoom(modalGallery) {
      if (!modalBody) return;

      const zones = modalGallery.querySelectorAll('.panzoom');

      zones.forEach((zone) => {
        if (zone._hasPanzoom) return;
        zone._hasPanzoom = true;

        const img = zone.querySelector('img');
        if (!img) return;

        const panzoom = Panzoom(img, {
          increment: 0.2,
          minScale: 1,
          maxScale: 2.5,
          duration: 200,
          disablePan: true,
          contain: 'outside',
        });

        let isZoomed = false;

        const pinchGuard = function (e) {
          if (window.innerWidth >= 990) return;

          if (!modal || !modal.classList.contains('is-open')) return;

          if (e.touches && e.touches.length > 1) {
            e.preventDefault();
          }
        };

        zone.addEventListener('touchstart', pinchGuard, {
          passive: false,
          capture: true,
        });
        zone.addEventListener('touchmove', pinchGuard, {
          passive: false,
          capture: true,
        });

        // desktop toggle zoom
        let pointerDownPos = null;
        const CLICK_TOL = 5; // px

        zone.addEventListener(
          'pointerdown',
          function (e) {
            if (window.innerWidth < 990) return;
            if (e.pointerType !== 'mouse') return; // ignore touch
            pointerDownPos = { x: e.clientX, y: e.clientY };
          },
          { capture: true }
        );

        zone.addEventListener(
          'pointerup',
          function (e) {
            if (window.innerWidth < 990) return;
            if (!pointerDownPos || e.pointerType !== 'mouse') return;

            const dx = Math.abs(e.clientX - pointerDownPos.x);
            const dy = Math.abs(e.clientY - pointerDownPos.y);
            pointerDownPos = null;

            if (dx > CLICK_TOL || dy > CLICK_TOL) return;

            // toggle zoom
            e.preventDefault();
            e.stopPropagation();

            if (!isZoomed) {
              panzoom.zoom(2.5, { animate: true, relative: false });
              isZoomed = true;
              img.classList.add('zoom-target');
            } else {
              panzoom.reset({ animate: true });
              isZoomed = false;
              img.classList.remove('zoom-target');
              img.classList.remove('zoom-move');
            }
          },
          { capture: true }
        );

        // auto toggle panning when scale changes
        img.addEventListener('panzoomchange', function (e) {
          const scale = e.detail && typeof e.detail.scale === 'number' ? e.detail.scale : panzoom.getScale();

          if (scale <= 1.01) {
            panzoom.setOptions({ disablePan: true });
            isZoomed = false;
            lastXEdge = null;

            // scroll slide normal when not zoom
            if (window.innerWidth < 990) {
              setTouchAction('auto');
            }
            return;
          }

          // touch action none to prevent scroll when zoomed
          panzoom.setOptions({ disablePan: false });
          isZoomed = true;

          if (window.innerWidth < 990 && lastXEdge === null) {
            setTouchAction('none');
          }
        });

        const EDGE_TOL = 2;
        let lastXEdge = null;
        let moveTimeout = null;

        // Zoom panning event
        img.addEventListener('panzoompan', function () {
          const scale = panzoom.getScale();
          if (scale <= 1.01) {
            img.classList.remove('zoom-move');
            return;
          }

          // cursor style move when drag mouse
          img.classList.add('zoom-move');

          // auto remove zoom-move when stop mouse
          if (moveTimeout) clearTimeout(moveTimeout);
          moveTimeout = setTimeout(function () {
            img.classList.remove('zoom-move');
          }, 300);

          const containerRect = zone.getBoundingClientRect();
          const imgRect = img.getBoundingClientRect();

          const atLeft = Math.abs(imgRect.left - containerRect.left) <= EDGE_TOL;
          const atRight = Math.abs(imgRect.right - containerRect.right) <= EDGE_TOL;

          let newEdge = null;
          if (atLeft) newEdge = 'left';
          else if (atRight) newEdge = 'right';

          if (newEdge) {
            // enable scroll when at edge
            if (newEdge !== lastXEdge) {
              setTouchAction('auto');
            }
          } else {
            // disable scroll when not at edge
            setTouchAction('none');
          }

          lastXEdge = newEdge;
        });

        // custom style touch action to apply scroll for mobile slide
        function setTouchAction(mode) {
          img.style.touchAction = mode;
          zone.style.touchAction = mode;
        }

        zone._pzReset = function () {
          // reset transform
          panzoom.reset({ animate: true });
          isZoomed = false;
          lastXEdge = null;
        };
      });
    }

    // close modal
    function closeVerticalGalleryModal() {
      if (!modal) return;

      // reset & destroy panzoom
      if (modalBody) {
        $(modalBody)
          .find('.panzoom img')
          .each(function () {
            const $img = $(this);
            if ($img.data('panzoom')) {
              try {
                $img.panzoom('reset');
                $img.panzoom('destroy');
              } catch (e) {}
            }
          });
      }

      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      $('html, body').removeClass('vertical-gallery-modal-open');
    }

    // click image open modal
    if ($gallery && modal && modalBody) {
      const galleryImages = $gallery.querySelectorAll('.vertical-gallery__item img');
      galleryImages.forEach(function (img, idx) {
        img.addEventListener('click', function () {
          const parent = img.closest('.vertical-gallery__item');
          let startIndex = idx;

          if (parent && parent.hasAttribute('data-image-index')) {
            startIndex = parseInt(parent.getAttribute('data-image-index'), 10) || idx;
          }

          openVerticalGalleryModal(startIndex);
        });
      });
    }

    // modal close click
    if (closeBtn) closeBtn.addEventListener('click', closeVerticalGalleryModal);
    if (overlay) overlay.addEventListener('click', closeVerticalGalleryModal);

    // close modal on ESC
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeVerticalGalleryModal();
      }
    });

    // gallery logic

    const CENTER_LOCK_TOL = 2;
    const VIS_RATIO_THRESHOLD = 0.5;

    // device helpers
    const isDesktop = () => window.innerWidth >= 990;
    const getMainItemSize = () => (isDesktop() ? $gallery.clientHeight : $gallery.clientWidth);
    const getMainScrollPos = () => (isDesktop() ? $gallery.scrollTop : $gallery.scrollLeft);
    const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

    // scroll main to index
    function scrollToIndexMain(index) {
      const size = getMainItemSize();
      const opts = { behavior: 'smooth', top: 0, left: 0 };
      if (isDesktop()) opts.top = index * size;
      else opts.left = index * size;
      $gallery.scrollTo(opts);
    }

    // get main index
    function getMainIndex() {
      const size = getMainItemSize();
      if (!size) return 0;
      return Math.round(getMainScrollPos() / size);
    }

    // pause hidden videos
    function pauseHiddenVideos() {
      const videos = $gallery.querySelectorAll('video');
      videos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        const visible = isDesktop()
          ? rect.top >= 0 && rect.bottom <= window.innerHeight
          : rect.left >= 0 && rect.right <= window.innerWidth;
        if (!visible && !video.paused) {
          video.pause();
          const $btn = $(video).closest('.vertical-gallery__item').find('.pdp-vertical-video-play');
          $btn.show();
        }
      });
    }

    // visible ratio
    function wrapperVisibleRatio(el) {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const visible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      const h = Math.max(1, r.height);
      return visible / h;
    }

    // center offset
    function wrapperCenterOffset(el) {
      const r = el.getBoundingClientRect();
      const center = r.top + r.height / 2;
      const vpCenter = window.innerHeight / 2;
      return center - vpCenter;
    }

    // update active states outside modal
    function updateActiveDot() {
      const idx = getMainIndex();

      $dots.forEach((d) => d.classList.remove('active'));
      if ($dots[idx]) $dots[idx].classList.add('active');

      $thumbs.forEach((t) => t.classList.remove('active'));
      if ($thumbs[idx]) {
        $thumbs[idx].classList.add('active');
        $thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    // dot click
    $dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        scrollToIndexMain(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    // thumb click
    $thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        scrollToIndexMain(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });

    // scroll update
    $gallery.addEventListener('scroll', function () {
      updateActiveDot();
      pauseHiddenVideos();
    });

    window.addEventListener('resize', updateActiveDot);
    updateActiveDot();

    // video play button
    $('.pdp-vertical-video-play').on('click', function () {
      var $btn = $(this);
      var $container = $btn.closest('.vertical-gallery__item');
      var $video = $container.find('video').get(0);
      if ($video && $video.paused) {
        $video.play();
        $btn.hide();
      }
    });

    $('.vertical-gallery__item video').on('click', function () {
      var $video = $(this).get(0);
      var $btn = $(this).closest('.vertical-gallery__item').find('.pdp-vertical-video-play');
      if ($video.paused) {
        $video.play();
        $btn.hide();
      } else {
        $video.pause();
        $btn.show();
      }
    });

    // scroll lock helpers
    let pendingCenterWrapper = null;
    let centerLocked = false;

    function updatePending() {
      if (!isDesktop()) {
        pendingCenterWrapper = null;
        centerLocked = false;
        return;
      }

      for (let i = 0; i < $wrappers.length; i++) {
        const el = $wrappers[i];
        if (wrapperVisibleRatio(el) > VIS_RATIO_THRESHOLD) {
          pendingCenterWrapper = el;
          return;
        }
      }
      pendingCenterWrapper = null;
      centerLocked = false;
    }

    window.addEventListener('scroll', updatePending, { passive: true });
    window.addEventListener('resize', updatePending);
    updatePending();

    // wheel lock
    window.addEventListener(
      'wheel',
      function onWheel(e) {
        if (modal && modal.classList.contains('is-open')) return;
        if (!isDesktop()) return;
        if (!pendingCenterWrapper) return;

        const ay = Math.abs(e.deltaY);
        const ax = Math.abs(e.deltaX);
        const primary = ay >= ax ? e.deltaY : e.deltaX;
        if (!primary) return;

        const maxScroll = $gallery.scrollHeight - $gallery.clientHeight;
        const curScroll = $gallery.scrollTop;

        const goingDown = primary > 0;
        const goingUp = primary < 0;

        const nearStart = curScroll <= 0;
        const nearEnd = curScroll >= maxScroll;

        if ((nearStart && goingUp) || (nearEnd && goingDown)) {
          centerLocked = false;
          return;
        }

        const offNow = wrapperCenterOffset(pendingCenterWrapper);

        if (!centerLocked) {
          if (Math.abs(offNow) > CENTER_LOCK_TOL) {
            e.preventDefault();
            window.scrollTo({
              top: window.scrollY + offNow,
              left: 0,
              behavior: 'smooth',
            });

            let armed = false;
            const onCenter = () => {
              const nowOff = wrapperCenterOffset(pendingCenterWrapper);
              if (Math.abs(nowOff) <= CENTER_LOCK_TOL) {
                centerLocked = true;
                armed = true;
                window.removeEventListener('scroll', onCenter);
              }
            };
            window.addEventListener('scroll', onCenter, { passive: true });

            setTimeout(() => {
              if (!armed) centerLocked = true;
              window.removeEventListener('scroll', onCenter);
            }, 600);

            return;
          } else {
            centerLocked = true;
          }
        }

        if (Math.abs(wrapperCenterOffset(pendingCenterWrapper)) > CENTER_LOCK_TOL) {
          centerLocked = false;
          return;
        }

        e.preventDefault();
        const nextScroll = clamp(curScroll + primary, 0, maxScroll);
        $gallery.scrollTop = nextScroll;
      },
      { passive: false, capture: true }
    );

    // keyboard lock
    document.addEventListener('keydown', function (e) {
      if (modal && modal.classList.contains('is-open')) return;
      if (!isDesktop()) return;
      if (!pendingCenterWrapper) return;

      let primary = 0;
      const STEP = $gallery.clientHeight * 0.1;

      if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === 'ArrowRight') primary = STEP;
      if (e.key === 'ArrowUp' || e.key === 'PageUp' || e.key === 'ArrowLeft') primary = -STEP;
      if (primary === 0) return;

      const maxScroll = $gallery.scrollHeight - $gallery.clientHeight;
      const curScroll = $gallery.scrollTop;

      const goingDown = primary > 0;
      const goingUp = primary < 0;

      const nearStart = curScroll <= 0;
      const nearEnd = curScroll >= maxScroll;

      if ((nearStart && goingUp) || (nearEnd && goingDown)) {
        centerLocked = false;
        return;
      }

      const offNow = wrapperCenterOffset(pendingCenterWrapper);

      if (!centerLocked) {
        if (Math.abs(offNow) > CENTER_LOCK_TOL) {
          e.preventDefault();
          window.scrollTo({
            top: window.scrollY + offNow,
            left: 0,
            behavior: 'smooth',
          });

          let armed = false;
          const onCenter = () => {
            const nowOff = wrapperCenterOffset(pendingCenterWrapper);
            if (Math.abs(nowOff) <= CENTER_LOCK_TOL) {
              centerLocked = true;
              armed = true;
              window.removeEventListener('scroll', onCenter);
            }
          };
          window.addEventListener('scroll', onCenter, { passive: true });

          setTimeout(() => {
            if (!armed) centerLocked = true;
            window.removeEventListener('scroll', onCenter);
          }, 600);

          return;
        } else {
          centerLocked = true;
        }
      }

      if (Math.abs(wrapperCenterOffset(pendingCenterWrapper)) > CENTER_LOCK_TOL) {
        centerLocked = false;
        return;
      }

      e.preventDefault();
      const nextScroll = clamp(curScroll + primary, 0, maxScroll);
      $gallery.scrollTop = nextScroll;
    });
  })();
});
